import React from 'react';
import { connect } from 'react-redux';
import { string, func } from 'prop-types';
import { Translate } from 'react-localize-redux';
import { Link } from 'react-router-dom';
import { routes } from '../../constants';
import { withLang } from '../../i18n';

import styles from './startSurvey.module.css';
import useTitle from '../../hooks/useTitle';

const Submitted = ({ surveyUrl, translate: t }) => {
  useTitle(t('startSurvey.submitSuccess'));
  return (
    <div className="page-container">
      <p className={styles.successMessage}>{t('startSurvey.submitSuccess')}</p>
      <p><Translate id="startSurvey.submitSuccessLinkExplanation" /><br />
        <a href={surveyUrl} target="_blank" rel="noopener noreferrer">{surveyUrl}</a>
      </p>
      <Link className="button--outline" to={routes.index}><Translate id="common.toFrontPage" /></Link>
    </div>
  );
};

Submitted.propTypes = {
  surveyUrl: string.isRequired,
  translate: func.isRequired
};

const mapStateToProps = ({ survey }) =>
  ({
    surveyUrl: survey.surveyUrl
  });

export default connect(mapStateToProps)(withLang(Submitted));
